import styled from 'styled-components';

export const StyledFooter = styled.footer`
  display: flex;
  background-color: #dbdbdb;
  justify-content: center;
  padding: 2rem;
`;